<template>
  <div class="animated fadeIn global-setting-page-container">
    <div class="h1-text">SETTINGS</div>
    <SubHeader></SubHeader>
    <TableGloBalSettings :loading="isLoading"></TableGloBalSettings>
    <div class="staff-management-container">
      <StaffManagement :staffSettings="settings.staffConfiguration"></StaffManagement>
    </div>
    <div class="h2-text margin-top-24px">
      Global Email Template
    </div>
    <div class="row">
      <div class="col-md-6" v-if="configEmail.emailTags.length">
        <div class="h3-text margin-top-24px">Reset Password Email Template</div>
        <vue-ckeditor
          v-model="settings.resetPasswordEmailTemplate.body"
          :config="configEmail" ></vue-ckeditor>
      </div>
      <div class="col-md-6" v-if="configEmail.emailTags.length">
        <div class="h3-text margin-top-24px">Temporary Password Email Template</div>
        <vue-ckeditor
          v-model="settings.temporaryPasswordEmailTemplate.body"
          :config="configEmail" ></vue-ckeditor>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 margin-top-24px">
        <button class="ap-btn primary" @click="saveData()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import TableGloBalSettings from '../../../components/globalSettings/TableGlobalSetttings';
import StaffManagement from '../../../components/globalSettings/StaffManagement';
import SubHeader from '../../../components/subHeaders/globalSettings/SubHeaderGlobalSettings';
import VueCkeditor from 'vue-ckeditor2';
import consts from '../../../_consts';
import {mapGetters, mapActions} from 'vuex';
export default {
  name: 'global-settings-view',
  components: {
    TableGloBalSettings,
    SubHeader,
    StaffManagement,
    VueCkeditor
  },
  data () {
    return {
      settings: {
        staffConfiguration: {},
        resetPasswordEmailTemplate: {},
        temporaryPasswordEmailTemplate: {}
      },
      configEmail: {
        // config for editor of email fields
        toolbar: [
          { name: 'clipboard', items: [ 'Undo', 'Redo' ] },
          { name: 'styles', items: [ 'Format', 'Font', 'FontSize' ] },
          { name: 'basicstyles', items: [ 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat', 'CopyFormatting' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'align', items: [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'paragraph', items: [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote' ] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'Event Fields', items: ['eventTags'] },
          { name: 'document', items: ['Source'] }
        ],
        height: 300,
        fullPage: true, // allow content contains html/body/head tags
        autoGrow_onStartup: true,
        toolbarCanCollapse: true,
        allowedContent: true,
        toolbarStartupExpanded: true,
        extraPlugins: 'eventTags',
        emailTags: []
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'GETTER_GET_IS_LOADING'
    })
  },
  methods: {
    saveData: async function () {
      this.$swal({
        title: "<div class='ems_alert_title'>Email Template Confirmation</div>",
        html: "<div class='ems_alert_des'>Are you sure to save these changes?</div>",
        confirmButtonColor: '#0080A5',
        confirmButtonText: 'SAVE',
        showCancelButton: true,
        cancelButtonColor: '#fff',
        cancelButtonText: 'CANCEL',
        buttonsStyling: true,
        reverseButtons: true,
        confirmButtonClass: 'ems_alert_confirm open',
        cancelButtonClass: 'ems_alert_cancel',
        customClass: 'ems_confirm',
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 605
      }).then((result) => {
        if (result.value) {
          let templates = [this.settings.resetPasswordEmailTemplate, this.settings.temporaryPasswordEmailTemplate];
          console.log('templates = ', templates);
          this.actionSaveTemplates(templates).then((responseSaveConfigs) => {
            if (!responseSaveConfigs.message) {
              this.$toast.success('Saved configurations!', '', {
                ...this.$toastOpt.optSuccess
              });
            } else {
              this.$toast.success(responseSaveConfigs.message, '', {
                ...this.$toastOpt.optError
              });
            }
            this.isLoading = false;
          });
        }
      });
    },
    ...mapActions({
      actionSaveTemplates: 'ACTION_SAVE_EMAIL_TEMPLATES',
      actionGetEmailTags: 'ACTION_GET_EMAIL_TAGS'
    })
  },
  created () {
    this.$store.dispatch('ACTION_GET_ALL_VALIDATORS').then((response) => {
      this.settings = response;
    });
    this.$store.commit('MUTATION_SET_MANAGER_VIEW', consts.viewNames.managerUsers);

    this.actionGetEmailTags().then((response) => {
      this.configEmail.emailTags = [];
      for (let tag of response.tags) {
        if (tag.useResetPassTemplate) {
          this.configEmail.emailTags.push(tag);
        }
      }
    });
  }
};
</script>


<style>

</style>



// WEBPACK FOOTER //
// GlobalSettings.vue?5d5d6970